import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d884a30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pricing", -1))
const _hoisted_4 = { class: "licenses" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "license-title" }
const _hoisted_7 = { class: "license-description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn" }, "Purchase", -1))
const _hoisted_9 = {
  key: 0,
  class: "license-single-use"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Looking for one time access? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenses, (license) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "license",
            key: license.id,
            onClick: ($event: any) => (_ctx.selectLicense(license))
          }, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(license.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(license.description), 1),
            _hoisted_8
          ], 8, _hoisted_5))
        }), 128))
      ]),
      (_ctx.singleLicense)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectLicense(_ctx.singleLicense)), ["prevent"]))
            }, " Try our bronze tier billed only once for $70. ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}